import styled from 'styled-components';

export const MaximizeIconWrapper = styled.button`
  margin-left: 2px;
  margin-top: 2px;
  background: none;
  border: 0px;
  filter: drop-shadow(0 0 1px rgba(0, 0, 0, 1)) drop-shadow(0 0 3px rgba(0, 0, 0, 0.7));
`;
